import { useFeatureFlag, isJSONTreatment } from '@moda/portal-stanchions';
import { colors } from '@moda/tokens';

export const useNavItemHighlighting = (label: string) => {
  const colorName = useFeatureFlag<undefined | string>('nav-items-highlighting', [
    {
      default: undefined
    },
    {
      getFromTreatment: treatment =>
        isJSONTreatment(treatment) ? treatment[label.toLowerCase()]?.toString() : undefined
    }
  ]);

  return { color: colorName ? colors.all[colorName as keyof typeof colors.all] : undefined };
};
